var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sh-zapier-card',{attrs:{"content-path":"/zapier-intro.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }